export enum EmploymentLength {
  FEWER_THAN_2_YEARS = "FEWER_THAN_2_YEARS",
  BETWEEN_2_AND_5_YEARS = "BETWEEN_2_AND_5_YEARS",
  MORE_THAN_5_YEARS = "MORE_THAN_5_YEARS",
}
